import { fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case actions.GET_CLAIMS+actions.FULFILLED:
            {
                return state.withMutations(mut => {
                    mut.set('claims', fromJS(action.payload));
                    return mut;
                });
            }
        case actions.GET_COURTSLIST + actions.FULFILLED:
            {
                return state.withMutations(mut => {
                    mut.set('courtsList', fromJS(action.payload));
                    return mut;
                });
            }
        case actions.GET_COURTTYPES + actions.FULFILLED:
            {
                return state.withMutations(mut => {
                    mut.set('courtTypes', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_PHONETYPES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('phoneTypes', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_GENERATIONS_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('generations', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_PROPERTITLES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('properTitles', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_STATES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('states', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_GRANT_TYPES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('grantTypes', fromJS(action.payload));
                    return mut;
                });
            }
        case 'GET_ROLES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('roles', fromJS(action.payload));
                    return mut;
                });
            }
        case actions.GET_PROGRAMDOCUMENTTYPES + actions.FULFILLED:
            {
                return state.set('programDocumentTypes', fromJS(action.payload));
            }
        case actions.GET_PERSONNEL_TYPES + actions.FULFILLED:
            {
                return state.set('personnelTypes', fromJS(action.payload));
            }
        case actions.GET_DISCIPLINES + actions.FULFILLED:
            return state.set('disciplines', fromJS(action.payload));

        case actions.GET_TRAINING_LOCATION_TYPES + actions.FULFILLED:
            return state.set('trainingLocationTypes', fromJS(action.payload))

        case actions.UPDATE_EVENT_TYPE:
            return state.set('eventType', action.payload)

        case actions.GET_TIME_ZONES + actions.FULFILLED:
            return state.set('timeZones', fromJS(action.payload))

        case actions.UPDATE_TIME_ZONE:
            return state.set('timeZone', action.payload)

        case actions.GET_PERSONDOCUMENTTYPES + actions.FULFILLED:
            return state.set('personDocumentTypes', fromJS(action.payload));

        case actions.GET_ADDRESSTYPES + actions.FULFILLED:
            return state.set('addressTypes', fromJS(action.payload));

        case actions.GET_JOURNALTYPES + actions.FULFILLED:
            return state.set('journalTypes', fromJS(action.payload));

        case actions.GET_JOURNAL_STATUS_TYPES + actions.FULFILLED:
            return state.set('journalStatusTypes', fromJS(action.payload));

        case actions.GET_APP_VERSION + actions.FULFILLED:
            return state.set('appVersion', action.payload);

        case actions.GET_PERSONTYPES + actions.FULFILLED:
            return state.set('personTypes', fromJS(action.payload));

        case actions.GET_TRAININGDOCUMENTTYPES + actions.FULFILLED:
            return state.set('trainingDocumentTypes', fromJS(action.payload));

        case actions.GET_COMMITTEEASSIGNMENTS + actions.FULFILLED:
            return state.set('committeeAssignments', fromJS(action.payload));

        case actions.GET_COUNTIES + actions.FULFILLED:
            return state.set('counties', fromJS(action.payload || []));

        case actions.GET_CITIES + actions.FULFILLED:
            return state.set('cities', fromJS(action.payload || []));

        case actions.NEW_JURISDICTION:
            return state.withMutations(mut => {
                mut.set('counties', fromJS([]));
                mut.set('cities', fromJS([]));
            })
           
        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        addressTypes: [],
        cities: [],
        claims: [],
        counties: [],
        courtsList: [],
        courtTypes: [],
        disciplines: [],
        grantTypes: [],
        generations: [],
        phoneTypes: [],
        properTitles: [],
        states: [],
        roles: [], 
        journalTypes: [],
        programTypes: [],
        personTypes: [],
        trainingLocationTypes: [],
        timeZones: [],
        personnelTypes: [],
        programDocumentTypes: [],
        personDocumentTypes: [],
        trainingDocumentTypes: [],
        committeeAssignments: [],
        appVersion: ''
    });
};